import { render } from "./CustomersSpendChart.vue?vue&type=template&id=2d2a66d5&scoped=true"
import script from "./CustomersSpendChart.vue?vue&type=script&lang=js"
export * from "./CustomersSpendChart.vue?vue&type=script&lang=js"

import "./CustomersSpendChart.vue?vue&type=style&index=0&id=2d2a66d5&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d2a66d5"],['__file',"src/components/CustomersSpendChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2d2a66d5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2d2a66d5', __exports__)) {
    api.reload('2d2a66d5', __exports__)
  }
  
  module.hot.accept("./CustomersSpendChart.vue?vue&type=template&id=2d2a66d5&scoped=true", () => {
    api.rerender('2d2a66d5', render)
  })

}


export default __exports__